import {
  DEBRIEF_SCHEDULES_PENDING,
  CULTURE_AUDIT_REPORT_PENDING,

  GET_DEBRIEF_SCHEDULES,
  GET_CULTURE_AUDIT_REPORTS,
  GET_GROUP_REPORT_PERMISSIONS,
  DELETE_DEBRIEF_SCHEDULE,
  SELECTED_DEBRIEF_SCHEDULE,
  RE_SELECTED_DEBRIEF_SCHEDULE,
  FETCH_DEBRIEF_SCHEDULE,
  EDIT_DEBRIEF_SCHEDULE,
  ADD_NEW_DEBRIEF_SCHEDULE,
  GET_AUDIT_ELIGIBLE,
  ADD_USER_TO_SURVEY,
  EXTEND_SURVEY_TIME,
  CLEAR_DEBRIEF_SCHEDULE,
  CLEAR_CULTURE_AUDIT_REPORT,
  ADD_ACTIVE_PAGE_DEBRIEF_SCHEDULE,
  GET_ACTIVE_PAGE_DEBRIEF_SCHEDULE,
  RESET_ADD_ACTIVE_PAGE_DEBRIEF_SCHEDULE,
  CLEAR_ALL,
  FIND_DEBRIEF_SCHEDULE,
  ADD_DEBRIEF_SCHEDULE_ADD_USERS_BULK,
  CULTURE_AUDIT_V2_TASK_UPDATE,
  GET_CULTURE_AUDIT_CACHE_METADATA,
  CLEAR_CULTURE_AUDIT_CACHE_RESULT,
  ADMIN_CULTURE_AUDIT_PRE_POPULATE_RESULT,
  ADMIN_CULTURE_AUDIT_PRE_POPULATE_BATCH_RESULT,
  ADMIN_CULTURE_AUDIT_CACHE_STATS,
  UPDATE_CULTURE_AUDIT_STATUS
} from "constants/actions";
import { ALL_ERRORS } from "constants/actions";

const initialState = {
  debrief_schedule: [],
  latest_schedule: [],
  culture_audit_reports: [],
  audit_eligible: [],
  user_added: false,
  survey_extended: false,
  debrief_id: null,
  pending: false,
  created: null,
  updated_debrief: null,
  deleted: false,
  activePage: 1,
  reportsPending: false,
  debrief_members_by_id: {},
  adding_users_bulk: false,
  last_bulk_add_result: null,
  bulk_add_error: null,
  // V2 Culture Audit state
  culture_audit_v2_task: { task_id: null, status: null, message: null },
  culture_audit_v2_cache_metadata: null,
  culture_audit_v2_cache_stats: null,
  culture_audit_v2_error: null,
  // Toast status for culture audit loading (Staples orgs only)
  culture_audit_status: null,
};


export default function DebriefSchedule(state = initialState, action) {
  switch (action.type) {
    case DEBRIEF_SCHEDULES_PENDING:
      return {
        ...state,
        pending: true,
        created: null,
        debrief_id: null,
        updated_debrief: null,
      };
    case CULTURE_AUDIT_REPORT_PENDING:
        return {
          ...state,
          reportsPending: true,
        };
    case GET_DEBRIEF_SCHEDULES:
      return {
        ...state,
        debrief_schedule: action.payload,
        pending: false,
        created: null,
      };
    case GET_CULTURE_AUDIT_REPORTS:
      return {
        ...state,
        culture_audit_reports: action.payload,
        pending: false,
        reportsPending: false,
      };
    case CULTURE_AUDIT_V2_TASK_UPDATE:
      return {
        ...state,
        culture_audit_v2_task: action.payload,
        reportsPending: action.payload.status === "queued" || action.payload.status === "processing",
      };
    case UPDATE_CULTURE_AUDIT_STATUS:
      return {
        ...state,
        culture_audit_status: action.payload,
      };
    case GET_CULTURE_AUDIT_CACHE_METADATA:
      return {
        ...state,
        culture_audit_v2_cache_metadata: action.payload,
        pending: false,
      };
    case CLEAR_CULTURE_AUDIT_CACHE_RESULT:
      return {
        ...state,
        culture_audit_v2_cache_metadata: null,
        pending: false,
      };
    case ADMIN_CULTURE_AUDIT_PRE_POPULATE_RESULT:
      return {
        ...state,
        pending: false,
      };
    case ADMIN_CULTURE_AUDIT_PRE_POPULATE_BATCH_RESULT:
      return {
        ...state,
        pending: false,
      };
    case ADMIN_CULTURE_AUDIT_CACHE_STATS:
      return {
        ...state,
        culture_audit_v2_cache_stats: action.payload,
        pending: false,
      };
    case GET_GROUP_REPORT_PERMISSIONS:
      return {
        ...state,
        culture_audit_reports: action.payload,
        pending: false,
        reportsPending: false,
      };
    case GET_AUDIT_ELIGIBLE:
      return {
        ...state,
        audit_eligible: action.payload,
        pending: false,
        created: null,
      };
    case ADD_USER_TO_SURVEY:
      return {
        ...state,
        user_added: action.payload,
        pending: false,
        created: null,
      };
    case EXTEND_SURVEY_TIME:
      return {
        ...state,
        survey_extended: action.payload,
        pending: false,
        created: null,
      };
    case GET_ACTIVE_PAGE_DEBRIEF_SCHEDULE:
      return {
        ...state,
        activePage: action.payload,
        pending: false,
      };
    case ADD_ACTIVE_PAGE_DEBRIEF_SCHEDULE:
      return {
        ...state,
        activePage: action.payload,
        pending: false,
      };
    case SELECTED_DEBRIEF_SCHEDULE:
      return {
        ...state,
        debrief_id: action.payload,
        pending: false,
      };
    case RE_SELECTED_DEBRIEF_SCHEDULE:
      return {
        ...state,
        debrief_id: null,
        pending: false,
      };

    case FIND_DEBRIEF_SCHEDULE:
      return {
        ...state,
        latest_schedule: action.payload,
        pending: false,
      };
    case FETCH_DEBRIEF_SCHEDULE:
        // console.log(action.payload)
        return {
          ...state,
          [action.payload.id]: action.payload,
          // debrief_id: action.payload.id,
          pending: false,
        };

    case EDIT_DEBRIEF_SCHEDULE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        debrief_id: action.payload.id,
        updated_debrief: true,
        created: null,
        pending: false,
      };

    case DELETE_DEBRIEF_SCHEDULE:
      const new_result = state.debrief_schedule.results.filter(
        (row) => row.id !== action.payload.id
      );

      // console.log(new_result)

      return {
        ...state,
        debrief_schedule: {
          ...(state.debrief_schedule.results = new_result),
        },
        created: null,
        updated_debrief: true,
        pending: false,
      };
    case RESET_ADD_ACTIVE_PAGE_DEBRIEF_SCHEDULE:
      return {
        ...state,
        created: null,
      };
    // Bulk add users to debrief schedule - saga trigger (pending)
    case "SG_ADD_DEBRIEF_SCHEDULE_ADD_USERS_BULK":
      return {
        ...state,
        adding_users_bulk: true,
        bulk_add_error: null,
        last_bulk_add_result: null,
        pending: true,
      };
    // Bulk add users to debrief schedule - success
    case ADD_DEBRIEF_SCHEDULE_ADD_USERS_BULK:
      // action.payload expected shape:
      // { debrief_schedule: number, created: number[], updated: number[], failed: [{ employee_id, error }] }
      return {
        ...state,
        adding_users_bulk: false,
        last_bulk_add_result: action.payload,
        bulk_add_error: null,
        pending: false,
        updated_debrief: true,
        created: null,
      };
    case ADD_NEW_DEBRIEF_SCHEDULE:
      // console.log(action.payload)
      return {
        ...state,
        created: action.payload,
        debrief_id: action.payload.id,
        pending: false,
        updated_debrief: true,
        // [action.payload.id]: action.payload,
        // debrief_schedule: [...state.debrief_schedule, action.payload],
        // debrief_id: null,
      };

    case CLEAR_DEBRIEF_SCHEDULE:
      return {
        ...state,
        debrief_schedule: [],
        latest_schedule: [],
        audit_eligible: [],
        user_added: false,
        survey_extended: false,
        debrief_id: null,
        pending: false,
        created: null,
        deleted: false,
        updated_debrief: null,
        activePage: 1,
        adding_users_bulk: false,
        last_bulk_add_result: null,
        bulk_add_error: null,
      };

    case CLEAR_CULTURE_AUDIT_REPORT:
        return {
          ...state,
          culture_audit_reports: [],
          reportsPending: false,
          culture_audit_status: null,
        };

    case CLEAR_ALL:
      return {
        ...state,
        debrief_schedule: [],
        culture_audit_reports: [],
        audit_eligible: [],
        user_added: false,
        survey_extended: false,
        updated_debrief: null,
        debrief_id: null,
        pending: false,
        created: null,
        deleted: false,
        activePage: 1,
        adding_users_bulk: false,
        last_bulk_add_result: null,
        bulk_add_error: null,
      };

    case "GET_DEBRIEF_MEMBERS": {
      const { id, data } = action.payload || {};
      if (!id) return state;
      return {
        ...state,
        debrief_members_by_id: {
          ...(state.debrief_members_by_id || {}),
          [id]: data, // expect shape { results: [...], count: n, ... }
        },
        pending: false,
      };
    }
    
    // Ensure loading flags are cleared on any error
    case ALL_ERRORS:
      return {
        ...state,
        pending: false,
        reportsPending: false,
        adding_users_bulk: false,
        bulk_add_error: action.payload || state.bulk_add_error,
        culture_audit_v2_error: action.payload || state.culture_audit_v2_error,
      };

    default:
      return state;
  }
}
